import { render, staticRenderFns } from "./Summoner.vue?vue&type=template&id=20ed0b11&"
import script from "./Summoner.vue?vue&type=script&lang=js&"
export * from "./Summoner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports